import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-937766ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "settlement-table"
};
const _hoisted_2 = {
  class: "table-header"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  class: "table-container"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "position": "relative"
  }
};
const _hoisted_8 = {
  style: {
    "min-width": "40px",
    "position": "relative"
  }
};
const _hoisted_9 = {
  key: 1,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_10 = {
  key: 2,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_11 = {
  key: 3,
  class: "editable-cell",
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_13 = {
  class: "two-line-ellipsis"
};
const _hoisted_14 = {
  key: 0,
  style: {
    "display": "flex",
    "gap": "8px",
    "margin-top": "4px",
    "overflow-x": "auto"
  }
};
const _hoisted_15 = {
  key: 4,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_16 = {
  key: 5,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_17 = {
  key: 6,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_18 = {
  key: 7,
  class: "editable-cell",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_19 = {
  class: "pagination-container"
};
const _hoisted_20 = {
  key: 4,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
import { defineComponent, onMounted, onBeforeUnmount } from 'vue';
import { QuestionCircleOutlined, EditOutlined, DownOutlined, ArrowRightOutlined } from '@ant-design/icons-vue';
import IOSBillModal from './IOSBillModal.vue';
import OtherReasonModal from './OtherReasonModal.vue';
import { useSettlementTable, columns, statusMap, reasonMap } from '../hooks/useSettlementTable';
export default /*#__PURE__*/_defineComponent({
  __name: 'SettlementTable',
  props: {
    loading: {
      type: Boolean
    },
    data: null,
    pagination: null,
    searchParams: null,
    allAccountList: null
  },
  emits: ['pagination-change', 'update-list', 'sort-change'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    defineComponent({
      name: 'SettlementTable'
    });
    const {
      modalVisible,
      otherReasonModalVisible,
      currentRecord,
      editFieldModalVisible,
      editingField,
      editingValue,
      editFieldTitle,
      usdValue,
      usdValueUnit,
      handleImportSettlement,
      handleExportAccount,
      handleEditCustomReason,
      handleOtherReasonConfirm,
      handleOtherReasonCancel,
      handleEditField,
      handleEditFieldConfirm,
      handleEditFieldCancel,
      handleStatusChange,
      changePage,
      handleTableChange,
      handleBatchModify,
      handleBatchModifyStatus,
      handleBatchUpdateStatus,
      handleBatchUpdateExpected,
      handleBatchUpdateReceived,
      handleBatchModifyActualReceiptTime,
      selectedRowKeys,
      onSelectChange,
      isBatchOperation,
      handleWithholdingTaxChange
    } = useSettlementTable(props, emit);
    let scrollTimer = null;
    const handleScroll = () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = window.setTimeout(() => {
        const e = new Event('resize');
        window.dispatchEvent(e);
      }, 0);
    };
    onMounted(() => {
      // 监听父容器的滚动事件
      const parentElement = document.querySelector('.financial-settlement');
      if (parentElement) {
        parentElement.addEventListener('scroll', handleScroll);
      }
    });
    onBeforeUnmount(() => {
      // 移除事件监听
      const parentElement = document.querySelector('.financial-settlement');
      if (parentElement) {
        parentElement.removeEventListener('scroll', handleScroll);
      }
    });
    return (_ctx, _cache) => {
      var _props$pagination, _props$pagination2, _props$pagination3;
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      const _component_a_alert = _resolveComponent("a-alert");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [_createVNode(_component_a_menu, null, {
          default: _withCtx(() => [_createVNode(_component_a_menu_item, {
            key: "1",
            onClick: _unref(handleBatchModify)
          }, {
            default: _withCtx(() => [_createTextVNode("修改账号余额")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_menu_item, {
            key: "2",
            onClick: _unref(handleBatchModifyStatus)
          }, {
            default: _withCtx(() => [_createTextVNode("修改预计收款时间")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_menu_item, {
            key: "6",
            onClick: _unref(handleBatchModifyActualReceiptTime)
          }, {
            default: _withCtx(() => [_createTextVNode("修改实际收款时间")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_menu_item, {
            key: "3",
            onClick: _unref(handleBatchUpdateStatus)
          }, {
            default: _withCtx(() => [_createTextVNode("修改收款状态")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_menu_item, {
            key: "4",
            onClick: _unref(handleBatchUpdateExpected)
          }, {
            default: _withCtx(() => [_createTextVNode("修改收款异常原因")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_menu_item, {
            key: "5",
            onClick: _unref(handleBatchUpdateReceived)
          }, {
            default: _withCtx(() => [_createTextVNode("更新收款信息")]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_a_button, {
          style: {
            "margin-right": "8px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 批量操作" + _toDisplayString(_unref(selectedRowKeys).length ? `(${_unref(selectedRowKeys).length})` : '') + " ", 1), _createVNode(_unref(DownOutlined))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
        type: "primary",
        onClick: _unref(handleImportSettlement)
      }, {
        default: _withCtx(() => [_createTextVNode("生成账单")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        onClick: _unref(handleExportAccount)
      }, {
        default: _withCtx(() => [_createTextVNode("导出账单")]),
        _: 1
      }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_table, {
        sticky: "",
        size: "small",
        loading: __props.loading,
        columns: _unref(columns),
        "data-source": __props.data,
        pagination: false,
        scroll: {
          x: 2470
        },
        "row-selection": {
          selectedRowKeys: _unref(selectedRowKeys),
          onChange: _unref(onSelectChange),
          getCheckboxProps: record => ({
            disabled: record.receivedStatus === 20
          })
        },
        "row-key": "id",
        onChange: _unref(handleTableChange),
        class: "custom-table"
      }, {
        headerCell: _withCtx(({
          column
        }) => [column.customTitle ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createTextVNode(_toDisplayString(column.title) + " ", 1), _createVNode(_component_a_tooltip, {
          title: column.tooltip
        }, {
          default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
            style: {
              "margin-left": "4px"
            }
          })]),
          _: 2
        }, 1032, ["title"])])) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref$record$receive, _unref$record$receive2, _unref$record$receive3, _unref$record$receive4, _unref$record$receive5, _unref$record$receive6, _record$receivedResEx3;
          return [column.key === 'accountName' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createTextVNode(_toDisplayString(record.accountName || '-') + " ", 1), record.isNeedExternalSettlement === 1 ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            "icon-class": "outSettle",
            class: "out-settlement-icon"
          })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), column.key === 'balance' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(record.balance ? Number(record.balance).toFixed(2) : '-'), 1)])) : _createCommentVNode("", true), column.key === 'receivedStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", {
            style: _normalizeStyle({
              color: ((_unref$record$receive = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive === void 0 ? void 0 : _unref$record$receive.color) === 'default' ? '#666' : ((_unref$record$receive2 = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive2 === void 0 ? void 0 : _unref$record$receive2.color) === 'warning' ? '#faad14' : ((_unref$record$receive3 = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive3 === void 0 ? void 0 : _unref$record$receive3.color) === 'success' ? '#52c41a' : ((_unref$record$receive4 = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive4 === void 0 ? void 0 : _unref$record$receive4.color) === 'error' ? '#ff4d4f' : (_unref$record$receive5 = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive5 === void 0 ? void 0 : _unref$record$receive5.color
            })
          }, _toDisplayString((_unref$record$receive6 = _unref(statusMap)[record.receivedStatus]) === null || _unref$record$receive6 === void 0 ? void 0 : _unref$record$receive6.text), 5), _createVNode(_component_a_select, {
            value: record.receivedStatus,
            "onUpdate:value": $event => record.receivedStatus = $event,
            style: {
              "width": "120px"
            },
            class: "edit-button",
            onChange: value => _unref(handleStatusChange)(value, record)
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select_option, {
              value: 0
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['0'].color === 'default' ? '#666' : _unref(statusMap)['0'].color
                })
              }, _toDisplayString(_unref(statusMap)['0'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 10
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['10'].color === 'warning' ? '#faad14' : _unref(statusMap)['10'].color
                })
              }, _toDisplayString(_unref(statusMap)['10'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 20
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['20'].color === 'success' ? '#52c41a' : _unref(statusMap)['20'].color
                })
              }, _toDisplayString(_unref(statusMap)['20'].text), 5)]),
              _: 1
            }), _createVNode(_component_a_select_option, {
              value: 30
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: _unref(statusMap)['30'].color === 'error' ? '#ff4d4f' : _unref(statusMap)['30'].color
                })
              }, _toDisplayString(_unref(statusMap)['30'].text), 5)]),
              _: 1
            })]),
            _: 2
          }, 1032, ["value", "onUpdate:value", "onChange"])])) : _createCommentVNode("", true), column.key === 'receivedResMsg' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_a_tooltip, {
            placement: "topLeft"
          }, {
            title: _withCtx(() => {
              var _record$receivedResEx;
              return [_createTextVNode(_toDisplayString(((_record$receivedResEx = record.receivedResExtInfo) === null || _record$receivedResEx === void 0 || (_record$receivedResEx = _record$receivedResEx.receivedResList) === null || _record$receivedResEx === void 0 ? void 0 : _record$receivedResEx.map(item => item.receivedResCode === 60 ? item.receivedResMsg : _unref(reasonMap)[item.receivedResCode]).filter(Boolean).join('；')) || '-'), 1)];
            }),
            default: _withCtx(() => {
              var _record$receivedResEx2;
              return [_createElementVNode("span", _hoisted_13, _toDisplayString(((_record$receivedResEx2 = record.receivedResExtInfo) === null || _record$receivedResEx2 === void 0 || (_record$receivedResEx2 = _record$receivedResEx2.receivedResList) === null || _record$receivedResEx2 === void 0 ? void 0 : _record$receivedResEx2.map(item => item.receivedResCode === 60 ? item.receivedResMsg : _unref(reasonMap)[item.receivedResCode]).filter(Boolean).join('；')) || '-'), 1)];
            }),
            _: 2
          }, 1024), _createVNode(_component_a_button, {
            type: "link",
            size: "small",
            class: "edit-button",
            onClick: $event => _unref(handleEditCustomReason)(record)
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
            _: 2
          }, 1032, ["onClick"])]), (_record$receivedResEx3 = record.receivedResExtInfo) !== null && _record$receivedResEx3 !== void 0 && (_record$receivedResEx3 = _record$receivedResEx3.imageList) !== null && _record$receivedResEx3 !== void 0 && _record$receivedResEx3.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.receivedResExtInfo.imageList, (img, index) => {
            return _openBlock(), _createBlock(_component_a_image, {
              key: index,
              src: img,
              alt: `异常原因图片${index + 1}`,
              style: {
                "width": "30px",
                "height": "30px",
                "object-fit": "cover"
              }
            }, null, 8, ["src", "alt"]);
          }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), column.key === 'expectedReceiptTime' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", null, _toDisplayString(record.expectedReceiptTime || '-'), 1), _createVNode(_component_a_button, {
            type: "link",
            size: "small",
            class: "edit-button",
            onClick: $event => _unref(handleEditField)(record, 'expectedReceiptTime')
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.key === 'actualReceivedAmount' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(record.actualReceivedAmount || '-'), 1), _createVNode(_component_a_button, {
            type: "link",
            size: "small",
            class: "edit-button",
            onClick: $event => _unref(handleEditField)(record, 'actualReceivedAmount')
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.key === 'actualReceiptTime' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("span", null, _toDisplayString(record.actualReceiptTime || '-'), 1), _createVNode(_component_a_button, {
            type: "link",
            size: "small",
            class: "edit-button",
            onClick: $event => _unref(handleEditField)(record, 'actualReceiptTime')
          }, {
            default: _withCtx(() => [_createVNode(_unref(EditOutlined))]),
            _: 2
          }, 1032, ["onClick"])])) : _createCommentVNode("", true), column.key === 'withholdingTax' ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(record.withholdingTax || '-'), 1)])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "columns", "data-source", "row-selection", "onChange"])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_a_pagination, {
        total: (_props$pagination = __props.pagination) === null || _props$pagination === void 0 ? void 0 : _props$pagination.total,
        onChange: _unref(changePage),
        current: (_props$pagination2 = __props.pagination) === null || _props$pagination2 === void 0 ? void 0 : _props$pagination2.current,
        pageSize: (_props$pagination3 = __props.pagination) === null || _props$pagination3 === void 0 ? void 0 : _props$pagination3.pageSize,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["total", "onChange", "current", "pageSize", "show-total"])]), _createVNode(OtherReasonModal, {
        "model-visible": _unref(otherReasonModalVisible),
        "onUpdate:model-visible": _cache[0] || (_cache[0] = $event => _isRef(otherReasonModalVisible) ? otherReasonModalVisible.value = $event : null),
        "current-record": _unref(currentRecord),
        "reason-map": _unref(reasonMap),
        onConfirm: _unref(handleOtherReasonConfirm),
        onCancel: _unref(handleOtherReasonCancel)
      }, null, 8, ["model-visible", "current-record", "reason-map", "onConfirm", "onCancel"]), _createVNode(_component_a_modal, {
        open: _unref(editFieldModalVisible),
        "onUpdate:open": _cache[7] || (_cache[7] = $event => _isRef(editFieldModalVisible) ? editFieldModalVisible.value = $event : null),
        title: _unref(editFieldTitle),
        onOk: _unref(handleEditFieldConfirm),
        onCancel: _unref(handleEditFieldCancel),
        centered: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, null, {
          default: _withCtx(() => [_unref(selectedRowKeys).length > 0 && _unref(isBatchOperation) ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: '已选择 ' + _unref(selectedRowKeys).length + ' 条记录'
          }, {
            default: _withCtx(() => [_createVNode(_component_a_alert, {
              type: "info",
              message: "此操作将批量修改所有选中记录，请谨慎操作"
            })]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: _unref(editFieldTitle)
          }, {
            default: _withCtx(() => [_unref(editingField) === 'expectedReceiptTime' ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 0,
              value: _unref(editingValue),
              "onUpdate:value": _cache[1] || (_cache[1] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              format: "YYYY-MM-DD"
            }, null, 8, ["value"])) : _unref(editingField) === 'actualReceivedAmount' || _unref(editingField) === 'balance' ? (_openBlock(), _createBlock(_component_a_input_number, {
              key: 1,
              value: _unref(editingValue),
              "onUpdate:value": _cache[2] || (_cache[2] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              precision: 2,
              min: 0,
              max: 100000000,
              placeholder: _unref(editingField) === 'balance' ? '请输入账号余额' : '请输入实际收款金额'
            }, null, 8, ["value", "placeholder"])) : _unref(editingField) === 'actualReceiptTime' ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 2,
              value: _unref(editingValue),
              "onUpdate:value": _cache[3] || (_cache[3] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              },
              format: "YYYY-MM-DD"
            }, null, 8, ["value"])) : _unref(editingField) === 'receivedStatus' ? (_openBlock(), _createBlock(_component_a_select, {
              key: 3,
              value: _unref(editingValue),
              "onUpdate:value": _cache[4] || (_cache[4] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select_option, {
                value: 0
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['0'].color === 'default' ? '#666' : _unref(statusMap)['0'].color
                  })
                }, _toDisplayString(_unref(statusMap)['0'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 10
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['10'].color === 'warning' ? '#faad14' : _unref(statusMap)['10'].color
                  })
                }, _toDisplayString(_unref(statusMap)['10'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 20
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['20'].color === 'success' ? '#52c41a' : _unref(statusMap)['20'].color
                  })
                }, _toDisplayString(_unref(statusMap)['20'].text), 5)]),
                _: 1
              }), _createVNode(_component_a_select_option, {
                value: 30
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: _normalizeStyle({
                    color: _unref(statusMap)['30'].color === 'error' ? '#ff4d4f' : _unref(statusMap)['30'].color
                  })
                }, _toDisplayString(_unref(statusMap)['30'].text), 5)]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])) : _unref(editingField) === 'withholdingTax' ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createVNode(_component_a_input_number, {
              value: _unref(usdValue),
              "onUpdate:value": _cache[5] || (_cache[5] = $event => _isRef(usdValue) ? usdValue.value = $event : null),
              "addon-after": "BRL",
              placeholder: "请输入预扣税",
              precision: 2,
              min: 0,
              max: 100000000,
              style: {
                "width": "190px"
              },
              onChange: _unref(handleWithholdingTaxChange)
            }, null, 8, ["value", "onChange"]), _createVNode(_unref(ArrowRightOutlined), {
              style: {
                "margin": "0 8px"
              }
            }), _createVNode(_component_a_input_number, {
              value: _unref(editingValue),
              "onUpdate:value": _cache[6] || (_cache[6] = $event => _isRef(editingValue) ? editingValue.value = $event : null),
              placeholder: "转换汇率后预扣税",
              precision: 2,
              min: 0,
              max: 100000000,
              "addon-after": _unref(usdValueUnit),
              style: {
                "width": "190px"
              }
            }, null, 8, ["value", "addon-after"])])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["open", "title", "onOk", "onCancel"]), _createVNode(IOSBillModal, {
        "model-visible": _unref(modalVisible),
        "onUpdate:model-visible": _cache[8] || (_cache[8] = $event => _isRef(modalVisible) ? modalVisible.value = $event : null),
        allAccountList: __props.allAccountList
      }, null, 8, ["model-visible", "allAccountList"])]);
    };
  }
});